
export default {
  name: "FurtherReading",
  props: {
    // [{ slug, title }]
    items: { type: Array, default: () => [] },
  },
};
